import * as React from "react";
import {
  updateProduct,
  updateSmsTemplate,
  getSmsTemplate,
  uploadPartnerDiscountLogo,
  uploadPartnerDiscountFile,
  rulesPatch,
  createRule
} from "../product/index";

import {
  Edit,
  SimpleForm,
  EditProps,
  TextInput,
  NumberInput,
  BooleanInput,
  ArrayInput,
  required,
  FunctionField,
  useRecordContext,
  SimpleFormIterator,
  ShowButton,
  TopToolbar,
  SelectInput,
  FileField,
  FileInput,
  Button,
  useNotify,
  SelectArrayInput
} from "react-admin";
import {
  makeStyles,
  TextField,
  CircularProgress,
  Snackbar,
  FormHelperText,
} from "@material-ui/core";
import { PinDropSharp } from "@material-ui/icons";

const validateRequired = [required("مقدار را وارد کنید")];
const paymentGatewaysOptions = [{ label: "کارت به کارت", value: "C2C" }, { label: "پی پینگ", value: "PAYPING" }, { label: "سامان", value: "LIMOOME_SAMAN" }, { label: "دیجی پی", value: "LIMOOME_DIGIPAY" }, { label: " اسنپ پی ", value: "SNAPP_PAY"}, { label: "تارا", value: "LIMOOME_TARA"}, { label: "باسا", value: "LIMOOME_BASA"} ];

const ListActions = (props: any) => {
  return (
    <TopToolbar>
      <ShowButton record={props.data} label="مشاهده" />
      {/* Add your custom actions */}
    </TopToolbar>
  );
};

const useStyles = makeStyles((theme) => ({
  width: {
    width: "30% !important",
  },
}));

export const ProductEdit = (props: EditProps): React.ReactElement => {
  const classes = useStyles();
  const notify = useNotify();
  const [currency, setCurrency] = React.useState("IRT");
  const [smsMessage, setSmsMessage] = React.useState("");
  const [logoUrl, setLogoUrl] = React.useState("");
  const [rulesEnabled, setRulesEnabled] = React.useState(false);
  const [serverState, setServerState] = React.useState({
    logo: { status: "NONE", message: "" },
    discountExcel: { status: "NONE", message: "" },
  });

  const save = async (values: any) => {
    const { rules, ...otherValues } = values; 
    const productData = { data: { ...otherValues, id: otherValues.id }, };
    if (logoUrl)
      productData.data.logoUrl = logoUrl;
    else if (productData.data.images)
      productData.data.logoUrl = productData.data.images;
    else productData.data.logoUrl = {};
    productData.data.logoUrl = logoUrl;

    try {
      let result: any = await updateProduct(productData);

      if (result && result.updateProduct) {
        if (result.updateProduct.id) {
          if (rules.length > 0 && rules[0].id) {
            try {
              let paramData = {
                id: rules[0].id,
                rulesEnabled: rules[0].isEnabled
              }
              let updateIsEnabled = await rulesPatch(paramData)
              if (updateIsEnabled.data && updateIsEnabled.data.id) {
                notify("ویرایش با موفقیت انجام شد", { type: 'success' })
  
                window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product`;
              }
            } catch (error) {
              notify("خطا در ویرایش", { type: 'error' })
  
            }   
          }else{
            const ruleData = await createRule({
              isEnabled: true,
              step: "BEFORE_SHOW_PRODUCT",
              ruleAddress: "http://localhost:3080/api/limoome-integrations/can-buy-diet"
          }, result.updateProduct.id);
          if (ruleData.createRule && ruleData.createRule.id) {
            notify("ویرایش با موفقیت انجام شد", { type: 'success' })
  
            window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product`;
          }else{
            notify("خطا در ویرایش", { type: 'error' })
  
          }
          }

        } else {


          notify("خطا در ویرایش", { type: 'error' })

        }

      }
    } catch (error) {
      console.log('error: ', error)
      notify("خطا در ویرایش", { type: 'error' })
    }

    if (productData.data.productType === "PARTNER_DISCOUNT") {
      let smsResult = await updateSmsTemplate(getProductId(), smsMessage);
    }
    window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product`;
  };

  const getProductId = () => {
    let location = window.location.hash.split("/");
    console.log("location: ", location);
    return location[location.length - 1];
  };

  const changeLogoUrl = async (file: any) => {
    console.log("file: ", file);
    if (!file) {
      setLogoUrl("");
      return;
    }

    setServerState({
      ...serverState,
      logo: { ...serverState.logo, status: "PENDING" },
    });
    uploadPartnerDiscountLogo(file)
      .then((res: any) => {
        setServerState({
          ...serverState,
          logo: { message: "عکس با موفقیت آپلود شد", status: "SUCCESSFUL" },
        });
        console.log("upload res: ", res);
        setLogoUrl(`${process.env.REACT_APP_LIMOOME_SERVER}/files/${res}`);
        document
          .querySelector(".MuiSnackbarContent-root")
          ?.classList.add("snack-successful");
      })
      .catch(() => {
        setServerState({
          ...serverState,
          logo: { message: "خطا در آپلود عکس", status: "ERROR" },
        });
        document
          .querySelector(".MuiSnackbarContent-root")
          ?.classList.add("snack-error");
      });
  };

  const importDiscountExcel = async (file: any) => {
    console.log("importDiscountExcel: ", file);
    if (!file) {
      return;
    }
    setServerState({
      ...serverState,
      logo: { ...serverState.logo, status: "PENDING" },
    });
    await uploadPartnerDiscountFile(file, getProductId(), file)
      .then((res: any) => {
        setServerState({
          ...serverState,
          logo: {
            message: `تعداد ${res} کد تخفیف با موفقیت ثبت شد.`,
            status: "SUCCESSFUL",
          },
        });
        document
          .querySelector(".MuiSnackbarContent-root")
          ?.classList.add("snack-successful");
      })
      .catch(() => {
        setServerState({
          ...serverState,
          logo: { message: "خطا در آپلود کد تخفیف", status: "ERROR" },
        });
        document
          .querySelector(".MuiSnackbarContent-root")
          ?.classList.add("snack-error");
      });
  };

  React.useEffect(() => {
    console.log("useEffect");
    let productId: string = getProductId();
    getSmsTemplate(productId).then((res: any) => {
      let smsTemplateResult = res;
      if (smsTemplateResult) setSmsMessage(smsTemplateResult.template);
    });
  }, []);

  const changeSmsMessage = React.useCallback((smsMessage) => {
    console.log("changeSmsMessage: ", smsMessage);
    setSmsMessage(smsMessage);
  }, []);

  const FieldByProductType = React.memo((props: any) => {
    // console.log('FieldByProductType: ', props);
    const [internalSmsMesssage, setInternalSmsMessage] = React.useState("");

    const record = useRecordContext();
    if (record.productType === "DIET") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات رژیم
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <BooleanInput
              className="is-allowed-mentor"
              style={{ width: "100%" }}
              label="دارای حامی"
              source="meta.isAllowedMentor"
            />
            <TextInput fullWidth label="کد رژیم" source="meta.productCode" />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <NumberInput
              fullWidth
              label="تعداد دوره"
              source="meta.count"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روزهای دوره"
              source="meta.days"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روز انقضا"
              source="meta.expiresAfter"
              isRequired
              validate={validateRequired}
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <FileInput
              onChange={(e: any) => changeLogoUrl(e)}
              fullWidth
              className="partner-upload-file"
              accept="image/*"
              labelSingle="برای آپلود لوگو کلیک کنید"
              source="partnerDiscountLogo"
            >
              <FileField source="src" title="partner-discount" />
            </FileInput>

            {serverState.logo.status !== "PENDING" ? (
              <FunctionField
                render={(record: any) => {
                  return logoUrl || record?.images?.logo ? (
                    <img
                      style={{ width: "100px" }}
                      src={logoUrl || record?.images?.logo}
                      alt="logo"
                    />
                  ) : (
                    ""
                  );
                }}
              />
            ) : (
              <FunctionField
                render={(record: any) => {
                  return <CircularProgress />;
                }}
              />
            )}
          </div>
        </div>
      );
    } else if (record.productType === "MENTOR") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات حامی
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <NumberInput
              fullWidth
              label="تعداد دوره"
              source="meta.count"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روزهای دوره"
              source="meta.days"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روز انقضا"
              source="meta.expiresAfter"
              isRequired
              validate={validateRequired}
            />
            <div>
              <TextInput fullWidth label="نوع حامی" source="meta.variation" />
              <FormHelperText>
                در صورتی که محصول لیموپلاس باشد این فیلد را با مقدار LIMOO_PLUS
                پر نمایید. در غیراین صورت فیلد را خالی بگذارید.
              </FormHelperText>
            </div>
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
        </div>
      );
    } else if (record.productType === "PSYCHOLOGY_SESSION") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات جلسه روان‌شناسی
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <NumberInput
              style={{ width: "100%" }}
              label="تعداد جلسات"
              source="meta.count"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              style={{ width: "100%" }}
              label="مدت زمان هر جلسه(دقیقه)"
              source="meta.sessionDuration"
              isRequired
              validate={validateRequired}
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
        </div>
      );
    } else if (record.productType === "PARTNER_DISCOUNT") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات تخفیف همکار
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <SelectInput
              fullWidth
              label="نوع تخفیف"
              source="meta.discountType"
              choices={[
                { id: "PERCENT", name: "درصد" },
                { id: "MONEY", name: "نقدی" },
              ]}
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="مقدار"
              source="meta.amount"
              isRequired
              validate={validateRequired}
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <Button
              style={{ justifyContent: "flex-end" }}
              fullWidth
              onClick={() => setSmsMessage(props.smsMessage + " ** ")}
              label="جایگذاری کد تخفیف در متن پیامک"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <TextField
              autoFocus
              multiline
              placeholder="متن پیامک را در این قسمت وارد کنید"
              fullWidth
              value={smsMessage}
              onChange={(e) => setSmsMessage(e.target.value)}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <FileInput
              onChange={(e: any) => importDiscountExcel(e)}
              className="partner-upload-file"
              fullWidth
              accept=".xlsx"
              labelSingle="برای آپلود فایل اکسل تخفیف کلیک کنید"
              source="attachment"
            >
              <FileField source="src" title="title" />
            </FileInput>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <FileInput
              onChange={(e: any) => changeLogoUrl(e)}
              fullWidth
              className="partner-upload-file"
              accept="image/*"
              labelSingle="برای آپلود لوگو کلیک کنید"
              source="partnerDiscountLogo"
            >
              <FileField source="src" title="partner-discount" />
            </FileInput>

            {serverState.logo.status !== "PENDING" ? (
              <FunctionField
                render={(record: any) => {
                  return logoUrl || record?.images?.logo ? (
                    <img
                      style={{ width: "100px" }}
                      src={logoUrl || record?.images?.logo}
                      alt="logo"
                    />
                  ) : (
                    ""
                  );
                }}
              />
            ) : (
              <FunctionField
                render={(record: any) => {
                  return <CircularProgress />;
                }}
              />
            )}
          </div>
        </div>
      );
    } else if (record.productType === "TAG") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات رژیم
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <TextInput
              fullWidth
              validate={validateRequired}
              isRequired
              label="نام دسته"
              source="meta.value"
            />
            <TextInput
              fullWidth
              label="تایپ صفحه انتخاب بسته"
              source="meta.selectPackageType"
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
        </div>
      );
    } else if (record.productType === "PRODUCT") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات رژیم
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <FileInput
              onChange={(e: any) => changeLogoUrl(e)}
              fullWidth
              className="partner-upload-file"
              accept="image/*"
              labelSingle="برای آپلود لوگو کلیک کنید"
              source="partnerDiscountLogo"
            >
              <FileField source="src" title="partner-discount" />
            </FileInput>

            {serverState.logo.status !== "PENDING" ? (
              <FunctionField
                render={(record: any) => {
                  return logoUrl || record?.images?.logo ? (
                    <img
                      style={{ width: "100px" }}
                      src={logoUrl || record?.images?.logo}
                      alt="logo"
                    />
                  ) : (
                    ""
                  );
                }}
              />
            ) : (
              <FunctionField
                render={(record: any) => {
                  return <CircularProgress />;
                }}
              />
            )}
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  });

  return (
    <Edit actions={<ListActions />} {...props}>
      <SimpleForm style={{ direction: "rtl" }} save={save}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput fullWidth label="ID" source="id" disabled={true} />
          <TextInput
            fullWidth
            label="نوع محصول"
            source="productType"
            isRequired
            validate={validateRequired}
            disabled={true}
          />
          <BooleanInput
            style={{ width: "100%" }}
            label="فعال/غیر فعال محصول"
            source="isEnabled"
          /> 
          <BooleanInput
            style={{ width: '100%' }}
            label="قابل خرید برای کاربران با رژیم فعال"
            source="rules[0].isEnabled"
            format={(value: any) => !value}    
            parse={(value: any) => !value}    
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput
            fullWidth
            label="عنوان"
            source="title"
            isRequired
            validate={validateRequired}
          />
          <TextInput fullWidth label="زیر عنوان" source="subtitle" />
          <TextInput fullWidth label="زیر عنوان دوم" source="subtitle2" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <NumberInput
            fullWidth
            label="تعداد روز انقضا سبد خرید"
            source="expiryPeriod"
            isRequired
            validate={validateRequired}
          />
          <TextInput fullWidth label="کد محصول" source="name" />
          <NumberInput fullWidth label="ترتیب نمایش" source="meta.showOrder" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput fullWidth label="توضیحات" multiline source="description" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <NumberInput fullWidth label="قیمت محصول" source="price" />
          <SelectInput
            fullWidth
            label="واحد"
            source="currency"
            choices={[{ id: "IRT", name: "تومان" }]}
            isRequired
            value={currency}
            onChange={(e: any) => setCurrency(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <NumberInput
            fullWidth
            label="مبلغ تخفیف"
            source="offValue"
            isRequired
            validate={validateRequired}
          />
          <TextInput fullWidth label="درصد تخفیف" source="offPercent" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput
            fullWidth
            label="وضعیت پیگیری"
            source="meta.orderTrackingUrl"
            defaultValue={""}
          />
          <TextInput
            fullWidth
            label="پیام موفقیت پرداخت "
            source="meta.paymentSuccessMessage"
            defaultValue={""}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <p style={{ fontFamily: "IranSans-Medium" }}>تگ‌ها:</p>
          <ArrayInput
            className="tag-input"
            style={{ width: "100%" }}
            label=" "
            source="meta.tags"
          >

            <SimpleFormIterator
              addButton={<Button label="اضافه کردن تگ"></Button>}
              removeButton={<Button label="حذف تگ" />}
            >
              <TextInput label="نام تگ" source="label" />
            </SimpleFormIterator>
          </ArrayInput>
        </div>

        <SelectArrayInput
          style={{ marginTop: '1rem' }}
          source="meta.paymentGateways"
          choices={paymentGatewaysOptions}
          optionText="label"
          optionValue="value"
          label="انتخاب درگاه پرداخت"
        />

        <FieldByProductType />

        <Snackbar
          open={
            serverState.logo.status === "ERROR" ||
              serverState.logo.status === "SUCCESSFUL"
              ? true
              : false
          }
          onClose={() => {
            setServerState({
              ...serverState,
              logo: { ...serverState.logo, status: "NONE" },
            });
          }}
          autoHideDuration={1500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          message={serverState.logo.message}
          style={{ backgroundColor: "transparent", borderRadius: "12px" }}
        />
        <Snackbar
          open={
            serverState.discountExcel.status === "ERROR" ||
              serverState.discountExcel.status === "SUCCESSFUL"
              ? true
              : false
          }
          onClose={() => {
            setServerState({
              ...serverState,
              discountExcel: { ...serverState.discountExcel, status: "NONE" },
            });
          }}
          autoHideDuration={1500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          message={serverState.discountExcel.message}
          style={{ backgroundColor: "transparent", borderRadius: "12px" }}
        />
      </SimpleForm>
    </Edit>
  );
};
